"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorage = exports.StorageProvider = exports.usePlatform = exports.PlatformProvider = void 0;
var Platform_1 = require("./Platform");
Object.defineProperty(exports, "PlatformProvider", { enumerable: true, get: function () { return Platform_1.PlatformProvider; } });
Object.defineProperty(exports, "usePlatform", { enumerable: true, get: function () { return Platform_1.usePlatform; } });
var useStorage_1 = require("./useStorage");
Object.defineProperty(exports, "useStorage", { enumerable: true, get: function () { return useStorage_1.useStorage; } });
Object.defineProperty(exports, "StorageProvider", { enumerable: true, get: function () { return useStorage_1.StorageProvider; } });
